import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  public getFooterType:BehaviorSubject<string> = new BehaviorSubject('type1');
  constructor() { }
}
